import React, { useEffect, useState } from "react";
import { Formik, FormikConsumer, useFormik } from "formik";
// import * as Yup from "yup";
import {
  TextField,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Box,
  Autocomplete,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "../../../components/common/Card";
import { addFuelPurchase, GetFuelDetails } from "../../../services/FuelService";
import { toast } from "react-toastify";
import { withErrorHandler } from "../../../utils/tryCatchHandler";
import {
  getShiftDetails1,
  getSiteDetails,
  getVendorDetails,
  saveVehicleDetails,
  saveVendorDetails,
  vehicleTypes,
} from "../../../services/vehicleService";
import { VolunteerActivismOutlined } from "@mui/icons-material";
import moment from "moment";
import axios from "axios";
const AddVehicleComponent = () => {
  const [fuelList, setFuelList] = useState([]);
  const [sitesList, setSitesLsit] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [activeTab, setActiveTab] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [frequencyList, setFrequency] = useState([
    "Hourly",
    "Daily",
    "Monthly",
  ]);

  const [vendorList, setVendorList] = useState([]);

  // const  []
  const formik = useFormik({
    initialValues: {
      siteId: "",
      siteIdState: [],
      shiftState: [],
      vendorState: null,
      make: "",
      modelNo: "",
      vehicleNumber: "",
      vehicleState: null,
      frequency: "",
      rate: "",
      manufactureYear: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    onSubmit: async (values) => {
      let arr = [1];
      // values.siteIdState.forEach((x) => {
      //   arr.push(x.siteId);
      // });
      let arr1 = [1];

      // values.shiftState.forEach((x) => {
      //   arr1.push(x.shiftId);
      // });

      let formdata = {
        siteIds: arr,
        shiftIds: arr1,
        registrationNumber: values.vehicleNumber,
        vendorId: values.vendorState?.vendorId,
        vehicleTypeId: values.vehicleState.vehicleTypeId,
        make: values.make,
        model: values.modelNo,
        pricePerMachine: values.rate,
        paymentType: values.frequency,
      };

      await console.log(formdata);
      await saveVehicleDetails(formdata)
        .then((res) => {
          if (res && res.data.statusDescription.statusCode == 200) {
            toast.success(res.data.statusDescription.description);
            let e;

            formik.handleReset(e);
          } else {
            toast.warn(res.data.statusDescription.description);
          }
        })
        .catch((err) => {});
    },
  });
  useEffect(() => {
    getAllDetails();
  }, []);

  const getAllDetails = async () => {
    await getSites()
      .then(getShiftDetails)
      .then(getVehiclees)
      .then(getVendorDetail)
      .then((data) => {});
  };

  const getVendorDetail = async () => {
    withErrorHandler(
      await getVendorDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          console.log(res.data);
          setVendorList(res.data.vendorDetails.content);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };

  const getSites = async () => {
    setSitesLsit([]);
    withErrorHandler(
      await getSiteDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          // console.log(res.data);
          setSitesLsit(res.data.siteDetails);
          formik.setFieldValue("siteIdState", res.data.siteDetails);
          // formik.setFieldValue("siteIdState", res.data.siteDetails[0]);
          // formik.setFieldValue("siteId", res.data.siteDetails[0].siteId);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };
  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setVehicleList(res.data.data);

          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(res.data.data[0].name);
            setActiveId(res.data.data[0].vehicleTypeId);
          }
        } else {
        }
      })
    );
  };

  const getShiftDetails = async () => {
    setShiftList([]);
    withErrorHandler(
      await getShiftDetails1().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setShiftList(res.data.shiftDetails);
          formik.setFieldValue("shiftState", res.data.shiftDetails);
          // formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);
          // formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);
        } else {
        }
      })
    );
  };

  return (
    <Card title={"Add Vehicle"}>
      <Box className="container mt-4">
        <form onSubmit={formik.handleSubmit} className="mt-4">
          <div className="row mb-2">
            {/* <div className="col-md-4 col-12  mb-2">
              <Autocomplete
                options={sitesList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                multiple
                // sx={{ width: 300 }}
                value={formik.values.siteIdState || []}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.siteName || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("siteIdState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("siteIdState", newValue);
                    console.log(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Sites`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={shiftList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                multiple
                // sx={{ width: 300 }}
                value={formik.values.shiftState || []}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("shiftState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("shiftState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Shift`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div> */}
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={vendorList || []}
                size="small"
                className="inp_search"
                label={"Vendor"}
                // sx={{ width: 300 }}
                value={formik.values.vendorState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("vendorState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("vendorState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Vendor`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={vehicleList || []}
                size="small"
                className="inp_search1"
                label={"Vendor"}
                // sx={{ width: 300 }}
                value={formik.values.vehicleState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("vehicleState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("vehicleState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Vehicle Type`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Make"
                name="make"
                size="small"
                value={formik.values.make}
                onChange={formik.handleChange}
                required
                error={formik.touched.make && Boolean(formik.errors.make)}
                helperText={
                  formik.touched.vehicleNumber && formik.errors.vehicleNumber
                }
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Model "
                name="modelNo"
                size="small"
                value={formik.values.modelNo}
                onChange={formik.handleChange}
                required
                error={formik.touched.modelNo && Boolean(formik.errors.modelNo)}
                helperText={formik.touched.modelNo && formik.errors.modelNo}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Manufacture Year "
                name="manufactureYear"
                size="small"
                value={formik.values.manufactureYear}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.manufactureYear &&
                  Boolean(formik.errors.manufactureYear)
                }
                helperText={
                  formik.touched.manufactureYear &&
                  formik.errors.manufactureYear
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Vehicle Number"
                name="vehicleNumber"
                size="small"
                value={formik.values.vehicleNumber}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.vehicleNumber &&
                  Boolean(formik.errors.vehicleNumber)
                }
                helperText={
                  formik.touched.vehicleNumber && formik.errors.vehicleNumber
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={frequencyList || []}
                size="small"
                className="inp_search2"
                label={"Frequency"}
                // sx={{ width: 300 }}
                value={formik.values.frequency || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("frequency", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("frequency", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Frequency`}
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Rate"
                name="rate"
                size="small"
                required
                value={formik.values.rate}
                onChange={formik.handleChange}
                error={formik.touched.rate && Boolean(formik.errors.rate)}
                helperText={formik.touched.rate && formik.errors.rate}
              />
            </div>
          </div>

          <div className="row mb-2">
            {/* <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Total Amount"
                name="totalAmount"
                size="small"
                disabled={true}
                required
                value={formik.values.totalAmount}
                onChange={formik.handleChange}
                error={
                  formik.touched.totalAmount &&
                  Boolean(formik.errors.totalAmount)
                }
                helperText={
                  formik.touched.totalAmount && formik.errors.totalAmount
                }
              />
            </div> */}
          </div>

          <div className="row">
            <div className="col-12 text-end d-flex justify-content-end">
              <Button
                type="reset"
                onClick={(e) => {
                  formik.handleReset(e);
                }}
                variant="contained"
                className="clr_btn me-3"
                color="secondary"
              >
                Clear
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="yellow_btn_1"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </Box>
    </Card>
  );
};

export default AddVehicleComponent;
